import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { User } from 'app/auth/models';
import { AuthenticationService } from 'app/auth/service';
import {
  OnelszamoloEgyseg,
  Raktar,
} from 'app/main/pages/torzsek/models/torzsek';
import { OnelszamoloEgysegekService } from 'app/main/pages/torzsek/services/onelszamolo-egysegek.service';
import { RaktarakService } from 'app/main/pages/torzsek/services/raktarak.service';
import { Observable, Subject } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { CoreSidebarService } from '../core-sidebar/core-sidebar.service';
import { CoreConfigService } from '@core/services/config.service';
import { parseJSON } from 'app/main/pages/torzsek/utils';

@Component({
  selector: 'core-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserSettingsComponent implements OnInit, OnDestroy {
  oek$: Observable<OnelszamoloEgyseg[]>;
  raktarak$: Observable<Raktar[]>;
  user$: Observable<User>;
  config: any;

  private destroy$ = new Subject();

  /**
   * Constructor

   * @param {CoreSidebarService} _coreSidebarService
   * */
  constructor(
    private authService: AuthenticationService,
    private oekService: OnelszamoloEgysegekService,
    private raktarakService: RaktarakService,
    private _coreSidebarService: CoreSidebarService,
    private _coreConfigService: CoreConfigService,
  ) {}

  ngOnInit(): void {
    this.user$ = this.authService.currentUser$;

    if(this.authService.currentUserValue && !this.authService.currentUserValue.munkatars) {

      this.oek$ = this.user$.pipe(
        filter((user: User | null) => !!user),
          switchMap((user: User) =>
            this.oekService.initData$.pipe(
              map((oek: any[]) => oek.filter((r: any) => user.oek.includes(r.id)))
            )
          )
      );
      this.raktarak$ = this.user$.pipe(
        switchMap((user: User) =>
          this.raktarakService.data$.pipe(
            map((raktarak: Raktar[]) =>
              raktarak.filter((r: Raktar) => r.oe_id === user?.oe)
            )
          )
        )
      );
    }

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebar(key): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }

  updateOnOeSelect(oe: OnelszamoloEgyseg): void {
    this.authService.currentUser = {
      ...this.authService.currentUserValue,
      oe: oe.id,
      raktar: oe.raktarak[0] ? oe.raktarak[0].id : null,
      oeNev: oe.megnevezes,
      kulfoldi_oe: oe.kulfoldi
    };

    let config = parseJSON(
          parseJSON(localStorage.getItem("currentUser"))?.beallitasok
        );
    this.config = config ? config : JSON.parse(localStorage.getItem('config'));
    this._coreConfigService.config = {
      ...this.config,
      user_settings: {
        oe: oe.id,
        raktar: oe.raktarak[0] ? oe.raktarak[0].id : null,
        columns: this.config.user_settings?.columns ? this.config.user_settings.columns : {}
      }
    }

    //window.location.reload();
  }
}
